module.exports = __webpack_public_path__ + "img/infoIcon.9bc73a2d.svg";